import { atom, useAtom } from 'jotai';

export const activeSessionAtom = atom(0); // 0 means new session

export function useActiveSessionAtom() {
  return useAtom(activeSessionAtom);
}